import styled from 'styled-components';
import { Chip as MuiChip } from '@material-ui/core';

export const Chip = styled(MuiChip)`
  margin: ${({ theme }) => theme.spacing(1)}px;
`;
